export default __webpack_public_path__ + "static/media/arrow-icon.85beed68.svg";